import { render, staticRenderFns } from "./HoribaIndexComponent.vue?vue&type=template&id=98b6339a"
import script from "./HoribaIndexComponent.vue?vue&type=script&lang=js"
export * from "./HoribaIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports